import { generateRGBA } from './generate-rgba';
import { isHex } from './is-hex';
import { isRGB } from './is-rgb';
import { isRGBA } from './is-rgba';
import { splitHex } from './split-hex';
import { splitRGB } from './split-rgb';

export function getRGBAColorWithOpacity (colorStr: string, alpha: string) {
  if (isRGB(colorStr) || isRGBA(colorStr)) {
    const [ r, g, b ] = splitRGB(colorStr);
    return generateRGBA(r, g, b, alpha.toString());
  }
  if (isHex(colorStr)) {
    const [ r, g, b ] = splitHex(colorStr);
    return generateRGBA(r, g, b, alpha.toString());
  }
  return colorStr;
}
